import { ComponentType } from 'react';
import { Bricks, BuildingFill, Cart4 } from 'react-bootstrap-icons';

export interface IndustryItem {
  id: string;
  title: string;
  Icon: ComponentType;
}

export const INDUSTRIES: IndustryItem[] = [
  {
    id: 'construction',
    title: 'Construtoras e empreiteiras',
    Icon: Bricks,
  },
  {
    id: 'accounting',
    title: 'Escritórios de contabilidade',
    Icon: BuildingFill,
  },
  {
    id: 'commerce',
    title: 'Comércios e prestadores de serviços',
    Icon: Cart4,
  },
];
